import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    centerAccess: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    emailField: {
      maxWidth: 160,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    centerLongFields: {
      fontSize: 12,
      maxWidth: 75,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    centerSmallFields: {
      textAlign: 'center',
      fontSize: 12,
      justifyContent: 'center',
      maxWidth: 30,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
      '& .makeStyles-cellContent': {
        justifyContent: 'center',
      },
      '& div': {
        justifyContent: 'center',
      },
    },
    formUser: {
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MusiGrid-container': {
        alignItems: 'center',
      },
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      paddingTop: 10,
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingBottom: 5,
    },
  });
